import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index";

import { createAuthGuards } from "./guards/auth";
import { applyGlobalGuards } from "./guards/globalGuards";
import { createRoutes } from "./routes/routes";

const guards = createAuthGuards({ store });

const routes = createRoutes({
  middlewareAuth: guards.middlewareAuth,
  middlewareGuest: guards.middlewareGuest,
  middlewareStoreAdmin: guards.middlewareStoreAdmin,
});

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

applyGlobalGuards(router, { store, isProtectedRoute: guards.isProtectedRoute });

export default router;
